// extracted by mini-css-extract-plugin
export default {"axis":"midpanel_axis__7sFQE"};